import axios from "axios";

export const API_URL_MODEL = "/webcam/model/api";
export const API_URL_STUDIO = "/webcam/studio/api";

axios.interceptors.response.use((response) => {
  if (response.data.message === "Unauthenticated.") {
    localStorage.removeItem("token");
    localStorage.clear();
    window.location.href = "/";
  }
  return response;
});
